import { TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { CUSTOM_FIELDS_FILTER_PARAM_KEY } from 'src/apps/dashboard/constants/CustomFields';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import { LabelsExcludedFromDashboard } from 'src/common/types/ConfigurationTypes';
import { ConditionOperators } from 'src/common/types/graphql.generated';

import { DashboardDataQueryVariables } from '../DashboardData.generated';

export const buildDashboardDataVariables = (
	days: number,
	filters?: IFilterOptions,
	labelsExcludedFromDashboard?: LabelsExcludedFromDashboard
): DashboardDataQueryVariables => {
	const variables: DashboardDataQueryVariables = {
		days,
		days2n: days * 2
	};

	const variablesBuilder = new QueryVariablesBuilder<DashboardDataQueryVariables>();

	if (filters) {
		const dynamicFilterOptions: TFilterOptions = omit(filters ?? {}, ['dateRange', 'searchValue']);

		variablesBuilder.addTupleFilterParam(
			CUSTOM_FIELDS_FILTER_PARAM_KEY,
			dynamicFilterOptions,
			ConditionOperators.All
		);
	}

	if (labelsExcludedFromDashboard && Object.keys(labelsExcludedFromDashboard).length > 0) {
		variablesBuilder.addNeTupleFilterParam(
			'customFieldsFilterExcludes' as keyof DashboardDataQueryVariables,
			labelsExcludedFromDashboard
		);
	}

	const builderVariables = variablesBuilder.getVariables();
	if (builderVariables.customFieldsFilter) {
		variables.customFieldsFilter = builderVariables.customFieldsFilter;
	}
	if (builderVariables.customFieldsFilterExcludes) {
		variables.customFieldsFilterExcludes = builderVariables.customFieldsFilterExcludes;
	}

	return variables;
};
